var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cloneObject } from './utils';
const GLOBAL = 'global';
export class NGConfig {
    init(config, db) {
        this._config = config;
        this._key = `${config.cid}.${config.aid}.config`;
        const data = localStorage.getItem(this._key);
        this._data = data ? JSON.parse(data) : {};
        this._collection = db.collection('config');
    }
    update(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = this._collection.doc(this._config.aid);
            try {
                yield doc.update(value);
            }
            catch (e) {
                if (e.code === 'not-found') {
                    yield doc.set(value);
                }
                else {
                    throw e;
                }
            }
        });
    }
    watch(callback, useCache = true) {
        return this._collection.doc(this._config.aid)
            .onSnapshot(snapshot => {
            if (snapshot.exists) {
                this._data = snapshot.data();
            }
            else {
                this._data = {};
            }
            this.saveData();
            callback(cloneObject(this._data));
        });
    }
    saveData() {
        localStorage.setItem(this._key, JSON.stringify(this._data));
    }
}
//# sourceMappingURL=NGConfig.js.map